import React from 'react';

export const AccessDenied: React.FC = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
            <div style={{ textAlign: 'center' }}>
                <h3>Access denied</h3>
                <p>You do not have permission to access this page.</p>
            </div>
        </div>
    );
};
